import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    setAdvantagesCheck, setCheckedFeature, setDifferenceOnly,
    storeLockedCompetitors
} from "../../../slices/vehicleSlice";

const CompareButton = ({vehicleCode, trimType, compareTrim, isCompare, secondaries, vehiclesTrim}) => {
    const isLocked = useSelector(storeLockedCompetitors);
    const selectedTrim = sessionStorage.getItem("selectedTrim");
    const isVehicleCodeValid = vehicleCode && Object.keys(vehicleCode).length > 0;
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const handleCompareTrims = () => {
        sessionStorage.setItem("isTrimSelected", JSON.stringify(true));
        dispatch(setCheckedFeature(false))
        dispatch(setDifferenceOnly(true))
        dispatch(setAdvantagesCheck(false))
        if (isCompare) {
            compareTrim(selectedTrim);
        } else if (isVehicleCodeValid) {
            compareTrim(vehicleCode.code, vehicleCode.media, vehicleCode.vehicle, trimType);
        }
    };

    const handleCompetitors = () => {
        sessionStorage.setItem("isTrimSelected", JSON.stringify(false));
        dispatch(setCheckedFeature(false));
        dispatch(setDifferenceOnly(false));
        dispatch(setAdvantagesCheck(true));
        if (isCompare) {
            secondaries(selectedTrim);
        } else if (isVehicleCodeValid) {
            compareTrim(vehicleCode.code, vehicleCode.media, vehicleCode.vehicle);
        }
    };

    return (
        <React.Fragment>
            <div className="trim-modal-footer">
                <button
                    className={
                        ((  vehicleCode && Object.keys(vehicleCode).length < 1) ||
                            vehicleCode === null ||
                            vehiclesTrim.length <=1 ||
                            Object.keys(isLocked).length === 3)
                            ? 'primary-btn-disabled'
                            : 'primary-btn'
                    }
                    onClick={handleCompareTrims}
                    disabled={  vehicleCode &&
                                Object.keys(vehicleCode).length < 1 ||
                                Object.keys(isLocked).length === 3 ||
                                vehiclesTrim.length <=1
                    }
                >
                    {t("overview.changeSelectModal.compareTrims")}
                </button>
                <button
                    className={
                        ((  vehicleCode && Object.keys(vehicleCode).length < 1) ||
                            vehicleCode === null ||
                            Object.keys(isLocked).length === 3)
                            ? 'primary-btn-disabled'
                            : 'primary-btn'
                    }
                    onClick={handleCompetitors}
                    disabled={  vehicleCode &&
                                Object.keys(vehicleCode).length < 1 ||
                                Object.keys(isLocked).length === 3
                    }
                >
                    {t("overview.changeSelectModal.competitors")}
                </button>
            </div>
        </React.Fragment>
    );
};

export default CompareButton;
